import React, { Component } from 'react';
import SeatLayout, { RoundTable, RectTable, SubTicket } from '../../../../seat-selector/seat-selector';
import { TableStatus } from '../../Enum/TableStatus';
import TableActionButtons from './TableActionButtons';
import { PropTypes } from 'prop-types';
import { PulseLoader } from 'halogenium';
import AccessLevel from '../../AccessLevel';
import EditShapeMenu from './table_canvas_components/EditShapeMenu';
import TableSessionHelper from '../../../../Model/TableSession';
import TableDetailRepository from '../../../repository/TableDetailRepository';
import MerchantAppData from '../../../../Model/MerchantAppData'
import BillRepository from '../../../repository/BillRepository';
import { TableSessionType } from '../../../../app/Common/Enum/TableSessionType';
import { BillStatus } from '../../../../Model/Bill';
import TableActiveTimeList from './TableActiveTimeList';
import './TableCanvasView.scss';
import MerchantSettingKey from '../../../../app/Common/Enum/MerchantSettingKey';
import TableCanvasViewTest from './TableCanvasViewTest';
const TABLE_ACTIVE_COLOR = '#00ff7f'

class TableCanvasView extends Component {
    static DEFAULT_DANGER_COLOR = "#ba000d"
    static DEFAULT_WARNING_COLOR = "#FFA500"
    static DEFAULT_DINE_IN_WITH_PAYMENT_COLOR = "#6495ED"
    constructor(props) {
        super(props);
        this.state = {
            canvasSelectedTable: null,
            tableRadius: this.getZoomLevel(),
            isEditMode: false,
            selectedAspectRatio: this.getAspectRatio(),
            customAspectRatio: this.getCustomAspectRatio(),
            allowScroll: this.getAllowScroll(),

            // http://robhoffmann.me/2016/03/12/Clearing-a-file-input-in-React/
            inputKey: Date.now(),

            isUploadingImage: false,

            // The details of table currently being edited
            tempTableDetail: null,

            // The color of SITTING table. Color coded by how long since last order
            // received this table.
            tableColor: {},

            // To compare if we need to recalculate table color
            tables: this.props.tables,
            sessions: this.props.parent.props.app.state.sessions,
            merchantSettings: this.props.parent.props.app.state.merchantSettings,

            // Store bills of dine in tables to check if already paid but table purposely not closed by
            // merchant for reference purpose
            bills: {},
        };

        // Reference for this.state.bills for this.setState race condition
        this.bills = {}

        this.tableCanvas = React.createRef()

        // For easy searching of table using table_id
        this.tableDetailMap = {}

        this.callbackKey = "TableCanvasView"

        // This one for unit testing use, so that test can access and 'click' to select the table
        this.seatLayoutTables = []
    }
    componentWillUnmount() {
        clearInterval(this.calculateTableColorTimer)
        TableDetailRepository.getInstance().removeCallback(null, this)
        BillRepository.getInstance().removeCallback(null, this)
    }
    getDefaultTableDetail = () => {
        return {
            x: 0.1,
            y: 0.1,
            width: this.state.tableRadius,
            height: this.state.tableRadius,
            type: 'circle',
            cr_tl: 0,
            cr_tr: 0,
            cr_bl: 0,
            cr_br: 0,
            show_border: true,
        }
    }
    componentDidMount() {
        this.props.onReady && this.props.onReady()
        this.seatLayout = new SeatLayout("seat-selector", this.state.tableRadius);

        this.setBackgroundImage()

        TableDetailRepository.getInstance().loadAll(tableDetails => {
            tableDetails.forEach(tableDetail => {
                this.tableDetailMap[tableDetail.table_id] = tableDetail
            })
            this.setState({
                tableDetails: tableDetails
            })
        }, this.callbackKey, this)
        this.calculateTableColor()

        // Recalculate every 15 second
        this.calculateTableColorTimer = setInterval(() => {
            this.calculateTableColor()
        }, 15 * 1000)

        if (window.is_unit_testing) {
            this.unitTest = TableCanvasViewTest.init(this)
        }
        $(document).trigger('TableCanvasView.ready')
    }
    componentDidUpdate(prevProps, prevState) {
        const {tables, sessions, merchantSettings, allOrders, tableSessionWithActiveOrders, } = this.state
        if (tables != this.props.tables ||
            sessions != this.props.parent.props.app.state.sessions ||
            allOrders != this.props.parent.props.app.state.allOrders ||
            merchantSettings != this.props.parent.props.app.state.merchantSettings ||
            tableSessionWithActiveOrders != this.props.parent.props.app.state.tableSessionWithActiveOrders ||
            prevState.bills != this.state.bills) {
            this.setState({
                tables: this.props.tables,
                sessions: this.props.parent.props.app.state.sessions,
                merchantSettings: this.props.parent.props.app.state.merchantSettings,
                allOrders: this.props.parent.props.app.state.allOrders,
                tableSessionWithActiveOrders: this.props.parent.props.app.state.tableSessionWithActiveOrders,
            })
            // When coming back from AdminOrder, this.props.tables will be [],
            // and might take a few cycle before it is loaded with data, so we need to
            // call calculateTableColor() on change of this.props.tables as well as on change
            // of merchantSetting (color codes) and tableSessions (updated_at)
            this.calculateTableColor()
        }
        if (this.seatLayout) {
            this.layoutTables()
        }
        this.setBackgroundImage()
    }
    setBackgroundImage = () => {
        let bgImageValue = null
        if (this.isHasMultipleFloor()) {
            const bgImage = this.props.parent.props.app.getMerchantSettingWithKeyInfo('table_canvas_view_bg_image', 'floor_level_' + this.props.selectedFloor)
            if (bgImage) {
                var lastChar = bgImage.key_info[bgImage.key_info.length - 1]
                if (this.props.selectedFloor == lastChar) {
                    bgImageValue = bgImage.value
                }
            }
        }
        else {
            const bgImage = this.props.parent.props.app.getMerchantSettingValue('table_canvas_view_bg_image')
            bgImageValue = bgImage || null
        }
        this.seatLayout.setBackgroundImage(bgImageValue)
    }
    zoom = (inOrOut) => {
        let tableRadius = this.state.tableRadius
        if (inOrOut == 'in') {
            tableRadius += 0.005
        }
        else if (inOrOut == 'out') {
            tableRadius -= 0.005
        }
        tableRadius = tableRadius <= 0 ? 0.005 : tableRadius
        this.setZoomLevel(tableRadius)
    }
    getZoomLevel = () => {
        return parseFloat((localStorage.getItem('table-view-table-radius') != "undefined" && localStorage.getItem('table-view-table-radius')) || this.props.tableRadius)
    }
    setZoomLevel = (tableRadius) => {
        localStorage.setItem('table-view-table-radius', tableRadius)
        this.setState({tableRadius})
    }
    clearTableCanvas = () => {
        if (!this.seatLayout) {return}
        this.seatLayout.clear()
    }

    getColorSetting = (description) => {
        return this.props.parent.props.app.getMerchantSettingValue(description)
    }
    getDangerColor = () => {
        return this.getColorSetting('table_canvas_view_danger_threshold_color') || TableCanvasView.DEFAULT_DANGER_COLOR
    }
    getWarningColor = () => {
        return this.getColorSetting('table_canvas_view_warning_threshold_color') || TableCanvasView.DEFAULT_WARNING_COLOR
    }
    getDineInWithPaymentColor = () => {
        return this.getColorSetting('table_canvas_view_dine_in_with_payment_color') || TableCanvasView.DEFAULT_DINE_IN_WITH_PAYMENT_COLOR
    }
    /**
     * Return color for table that already closed bill but merchant decide to leave the table unclosed
     */
    getDineInClosedBillColor = () => {
        return this.getColorSetting('table_canvas_view_dine_in_with_payment_color') || TableCanvasView.DEFAULT_DINE_IN_WITH_PAYMENT_COLOR
    }
    getWarningThreshold = () => {
        return this.getColorSetting('table_canvas_view_warning_threshold_minute') || 15
    }
    getDangerThreshold = () => {
        return this.getColorSetting('table_canvas_view_danger_threshold_minute') || 30
    }
    loadBill = (billId) => {
        billId = parseInt(billId)

        // Bill not loaded, load now
        BillRepository.getInstance().loadOne(billId, (bill) => {
            let bills = {...this.bills}
            bills[billId] = bill
            this.bills = bills

            if (this.billTimer) {
                clearTimeout(this.billTimer)
            }

            // Add throttle to prevent keep updating UI
            this.billTimer = setTimeout(() => {
                this.setState({bills: this.bills})
            }, 200);
        }, this.callbackKey, this)
    }
    isDineInAlreadyClosedBill = (tableSession) => {
        if (tableSession && tableSession.table_session_type_id != TableSessionType.DINE_IN || !tableSession.bill_id) {
            return false
        }

        const { bills, } = this.state
        const bill = bills[tableSession.bill_id]
        if (!bill) {
            // Load bill and wait for setState to trigger this function again
            this.loadBill(tableSession.bill_id)
            return false
        }
        return bill.status == BillStatus.CLOSED
    }
    calculateTableColor = () => {
        let tableColor = {}
        this.props.tables.forEach(table => {
            const tableSessions = TableSessionHelper.getSessionsForTableWithActiveOrders(table)
            if (tableSessions.length == 0) {
                return
            }

            if (tableSessions[0].pickup_table_id) {
                tableColor[table.id] = this.getDineInWithPaymentColor()
                return
            }
            if (this.isDineInAlreadyClosedBill(tableSessions[0])) {
                tableColor[table.id] = this.getDineInClosedBillColor()
                return
            }
            let lastOrderTime = tableSessions[0].updated_at
            tableSessions.forEach(tableSession => {
                // tableSession.updated_at - lastOrderTime
                if (moment(tableSession.updated_at).diff(moment(lastOrderTime)) > 0) {
                    lastOrderTime = tableSession.updated_at
                }
            })

            // Found search last order time, workout table color
            // now - lastOrderTime
            tableColor[table.id] = this.getDineInTableColor(lastOrderTime)
        })
        this.setState({tableColor})
    }

    getDineInTableColor = (lastOrderTime) => {
        let warningColor = this.getWarningColor()
        let dangerColor = this.getDangerColor()

        // Found search last order time, workout table color
        // now - lastOrderTime
        const diff = moment().diff(moment(lastOrderTime)) // diff in milisecond
        const diffMinute = diff / 1000 / 60    // diff in minutes
        const warningMinute = this.getWarningThreshold()
        const dangerMinute = this.getDangerThreshold()
        const activeColor = TABLE_ACTIVE_COLOR
        if (diffMinute > dangerMinute) {
            return dangerColor
        }
        else if (diffMinute > warningMinute) {
            return warningColor
        }
        else {
            return activeColor
        }
    }

    isHasMultipleFloor = () => {
        if (this.props.floors != null && this.props.floors.data != null && this.props.floors.data.length && this.props.floors.data[0].id != -1) {
            return true
        }
        return false
    }

    layoutTables = () => {
        const canvasWidth = this.tableCanvas.current.clientWidth
        const canvasHeight = this.tableCanvas.current.clientHeight
        this.tableCanvas.current.width  = canvasWidth
        this.tableCanvas.current.height = canvasHeight
        const tableRadius = this.state.tableRadius * canvasWidth;

        if (!this.seatLayout) {
            this.seatLayout = new SeatLayout("seat-selector", tableRadius);
        }
        const seatLayout = this.seatLayout
        seatLayout.removeAll()
        seatLayout.setSize({width:canvasWidth,height:canvasHeight});

        this.seatLayoutTables = []
        let filteredTable = this.props.tables
        let currentFloor = null
        let defaultFloor = null

        if (this.props.floors != null && this.props.floors.data != null) {
            currentFloor = this.props.selectedFloor

            // Filter the table that belongs to the selected floor only
            filteredTable = this.props.tables.filter( table => table.floor_level_id == currentFloor )

            // If current floor is first floor,
            // Handle default floor (floors.data[0]) to remove all tables that has explicitly setup floor_id, but is not of default floor.
            // Assume default floor = Floor 1
            // Table 1 - Floor 1
            // Table 2 - null
            // Table 3 - Floor 2
            // When we select default Floor 1, then show Table 1 and Table 2, remove Table 3 due to it's explicitly set to Floor 2
            if (this.props.selectedFloor == this.props.floors.data[0].id) {
                filteredTable = this.props.tables.filter( table => table.floor_level_id == null || table.floor_level_id == currentFloor )
            }
        }

        filteredTable.forEach((table) => {
            const isTableSelected = this.state.canvasSelectedTable && this.state.canvasSelectedTable.id == table.id
            const editDetail = isTableSelected && this.state.isEditMode && this.state.tempTableDetail && this.state.tempTableDetail.relative
            let tableDetail = editDetail || this.tableDetailMap[table.id];

            if (!tableDetail) {
                tableDetail = this.getDefaultTableDetail()
                this.tableDetailMap[table.id] = tableDetail
            }

            let table1 = new RoundTable();
            if (tableDetail.type == 'roundrect') {
                table1 = new RectTable();
                table1.cornerRadius = {
                    upperLeft: (tableDetail.cr_tl || 0),
                    upperRight: (tableDetail.cr_tr || 0),
                    lowerLeft: (tableDetail.cr_bl || 0),
                    lowerRight: (tableDetail.cr_br || 0),
                }
            }

            table1.onSelected = () => {
                const selectedTable = this.props.tables.find(table => table.id == table1.id)

                const executeSelectTable = () => {
                    if (!this.state.isEditMode && this.props.goToOrderPage) {
                        this.props.goToOrderPage(selectedTable.id, () => {
                            $(document).trigger('tableCanvas.table.clicked', selectedTable.id)
                        })
                        return
                    }
                    let tempTableDetail = null

                    if (tableDetail) {
                        const relative = {
                            ...this.tableDetailMap[table.id],
                        }
                        tempTableDetail = {
                            relative: relative,
                            absolute: this.transformCoordinateToAbsolute(relative, this.canvasWidth, this.canvasHeight)
                        }
                    }

                    // We will set 'tempTableDetail' regardless isEditMode or not to simplify
                    // things when user change mode
                    this.setState({
                        canvasSelectedTable: selectedTable,
                        tempTableDetail: tempTableDetail,
                    })
                }
                if (this.props.isAllowSelectTable) {
                    if (!this.props.isAllowSelectTable(selectedTable, executeSelectTable)) {
                        return
                    }
                }
            }
            table1.onFinalize = () => {
                const savingState = {isSaving:true}
                let newCenter = {
                    x: table1.center.x / canvasWidth,
                    y: table1.center.y / canvasHeight
                }

                // Save the temporary position so that table don't "jump"
                // back to original position on setState, then "jump"
                // again to new position on Firebase update completed
                this.tableDetailMap[table1.id] = {
                    ...this.tableDetailMap[table1.id],
                    x: newCenter.x,
                    y: newCenter.y,
                }
                if (canvasSelectedTable && canvasSelectedTable.id == table1.id && this.state.tempTableDetail) {
                    let relative = {
                        ...this.state.tempTableDetail.relative,
                        x: newCenter.x,
                        y: newCenter.y,
                    }
                    savingState['tempTableDetail'] = {
                        relative: relative,
                        absolute: this.transformCoordinateToAbsolute(relative, this.canvasWidth, this.canvasHeight)
                    }
                }

                this.setState(savingState)
                $.ajax({
                    url     : `/merchant/api/table/${table.id}/update_detail`,
                    type    : 'post',
                    data    : {
                        x: table1.center.x / canvasWidth,
                        y: table1.center.y / canvasHeight,
                        type: table1.type,
                        width: (table1.width && (table1.width / canvasWidth)) || null,
                        height: (table1.height && (table1.height / canvasHeight)) || null,
                    },
                    success : (res) => {
                        this.setState({isSaving:false})
                    }
                })
            }
            table1.id = table.id;
            table1.sortPriority = 100;

            if (table.center) {
                table1.center = {x:table.center.x * canvasWidth, y:table.center.y * canvasHeight};
            }
            else {
                table1.center = {
                    x: tableDetail.x * canvasWidth,
                    y: tableDetail.y * canvasHeight,
                }
            }

            table1.name = table.name
            table1.showBorder = tableDetail.show_border
            table1.width = tableDetail.width * canvasWidth
            table1.height = tableDetail.height * canvasHeight
            table1.radius = tableDetail.width * canvasWidth / 2

            let tickets = this.getTableSessionThatHasOrder(table)
            if (tickets.length > 1) {
                for (let i = 1; i < tickets.length; i++) {
                    let tableSession = tickets[i]
                    let subTicket = new SubTicket()

                    if (tableSession.pickup_table_id) {
                        subTicket.color = this.getDineInWithPaymentColor()
                    }
                    else if (this.isDineInAlreadyClosedBill(tableSession)) {
                        subTicket.color = this.getDineInClosedBillColor()
                    }
                    else {
                        subTicket.color = this.getDineInTableColor(tableSession.updated_at)
                    }
                    subTicket.addToLayout(table1)
                }
            }

            const canvasSelectedTable = this.state.canvasSelectedTable
            table1.isSelected = canvasSelectedTable && (canvasSelectedTable.id == table.id)

            const tableStatus = this.props.parent.getTableStatus(table);

            if ((tableStatus == TableStatus.BILLING || tableStatus == TableStatus.SITTING) && this.state.tableColor[table.id]) {
                table1.color = this.state.tableColor[table.id]
            }

            if (table.status == "active") {
                table1.addToLayout(seatLayout)

                // So that unit testing can access and 'click' to select the table
                this.seatLayoutTables.push(table1)
            }
        })
        seatLayout.render();
    }
    getTableSessionThatHasOrder = (table) => {
        let tableSessions = TableSessionHelper.getSessionsForTableWithActiveOrders(table)
        return tableSessions || []
    }
    onSaveTableDetailsClicked = () => {
        const {canvasSelectedTable, tempTableDetail} = this.state
        const data = {...tempTableDetail.relative}

        // Boolean to 1 or 0
        data.show_border = !!data.show_border ? 1 : 0
        this.setState({isSaving:true})
        this.saveTableDetails(canvasSelectedTable,data)
    }
    saveTableDetails = (table, data) => {
        $.ajax({
            url     : `/merchant/api/table/${table.id}/update_detail`,
            type    : 'post',
            data    : data,
            success : (res) => {
                this.setState({isSaving:false})
            }
        })
    }
    toggleEditMode = () => {
        this.setState({
            isEditMode: !this.state.isEditMode
        }, () => {
            this.props.parent.forceUpdate()
            if (this.seatLayout) {
                this.seatLayout.setEditMode(this.state.isEditMode)
            }
        })
    }

    getButtons = () => {
        const allowEditTableCanvas = AccessLevel.allowEditTableCanvas()
        const {isEditMode} = this.state
        return <React.Fragment>
            <span style={{display:"inline-block", magin: "auto 0px"}}>
                {this.settingsDropdown()}
            </span>
            {/* This to trigger redraw manually */}
            {/* <button className="btn btn-default" onClick={this.layoutTables}>
                Redraw
            </button> */}
            {
                allowEditTableCanvas &&
                <button className="btn btn-default" onClick={this.toggleEditMode}>
                    {isEditMode ? "End Edit Mode" : "Edit Mode"}
                </button>
            }

            {/* No longer used */}
            {/* <button className="btn btn-default" onClick={() => this.zoom('in')}>
                +
            </button>
            <button className="btn btn-default" onClick={() => this.zoom('out')}>
                -
            </button> */}
        </React.Fragment>
    }

    onAspectRatioChanged = (aspectRatio) => {
        if (aspectRatio == 'Custom') {
            let success = false
            let customAspectRatio = prompt("Set your aspect ratio, X:Y")
            if (customAspectRatio) {
                if (customAspectRatio.match(/\d+:\d+/)) {
                    success = true
                    this.setCustomAspectRatio(customAspectRatio)
                }
                else {
                    alert("Invalid format. Example format is 4:3, 16:9, etc")
                }
            }
            if (!success) {
                alert("Aspect ratio not set.")
            }
        }

        // aspectRatio changed, shall update the absolute coordinate of the selected table as well
        this.setAspectRatio(aspectRatio, () => {
            if (this.state.tempTableDetail) {
                this.setState({
                    tempTableDetail: {
                        relative: this.state.tempTableDetail.relative,
                        absolute: this.transformCoordinateToAbsolute(this.state.tempTableDetail.relative, this.canvasWidth, this.canvasHeight)
                    }
                })
            }
        })
    }
    getAspectRatio = () => {
        const aspectRatio = localStorage.getItem("table-view-aspect-ratio") || "4:3"
        return aspectRatio
    }
    setAspectRatio = (aspectRatio, callback) => {
        let result = localStorage.setItem("table-view-aspect-ratio", aspectRatio)
        this.setState(
            {selectedAspectRatio: aspectRatio},
            () => {
                this.props.parent.forceUpdate()
                callback && callback()
            }
        )
        return result
    }
    getCustomAspectRatio = () => {
        const aspectRatio = localStorage.getItem("table-view-custom-aspect-ratio") || ""
        return aspectRatio
    }
    setCustomAspectRatio = (aspectRatio) => {
        let result = localStorage.setItem("table-view-custom-aspect-ratio", aspectRatio)
        this.setState({customAspectRatio: aspectRatio})
        return result
    }
    getAllowScroll = () => {
        // LocalStorage store string value
        let value = localStorage.getItem("table-view-allow-scroll") || "false"
        return JSON.parse(value)
    }
    setAllowScroll = (allowScroll) => {
        let result = localStorage.setItem("table-view-allow-scroll", allowScroll)
        this.setState(
            {allowScroll},
            () => this.props.parent.forceUpdate()
        )
        return result
    }
    onAllowScrollChanged = () => {
        this.setAllowScroll(!this.state.allowScroll)
    }
    uploadBackgroundImage = (e) => {
        this.setState(
            {isUploadingImage: true},
            () => this.props.parent.forceUpdate()
        )

        let formData = new FormData();
        formData.append("fileToUpload", e.target.files[0])

        if (this.props.selectedFloor) {
            formData.append("floor_level_id", this.props.selectedFloor)
        }
        $.ajax({
            url: '/merchant/api/upload_table_canvas_bg',
            type: 'post',
            data: formData,
            cache       : false,
            contentType : false,
            processData : false,
            success: (res) => {
                this.seatLayout.setBackgroundImage(res)
                this.setState(
                    {inputKey: Date.now(), isUploadingImage: false},
                    () => this.props.parent.forceUpdate()
                )
            }
        })
        .fail(ajaxFails)
    }
    settingsDropdown = () => {
        const {selectedAspectRatio, allowScroll, isUploadingImage, inputKey, customAspectRatio} = this.state
        let aspectRatios = [
            "1:1",
            "4:3",
            "5:4",
            "6:5",
            "11:8",
            "16:9",
            "Custom"
        ]
        const tickSymbol = <span className="pull-right" style={{color:"green"}}>&#10004;</span>
        const allowEditTableCanvas = AccessLevel.allowEditTableCanvas()
        return <div>
            <div className="btn-group">
                <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {lang.settings} <span className="caret"></span>
                </button>
                <ul className="dropdown-menu">
                    <li>
                        <a onClick={this.onAllowScrollChanged}>
                            {allowScroll && tickSymbol}
                            <span>Allow Scroll</span>
                        </a>
                    </li>
                    {
                        allowEditTableCanvas &&
                        <>
                        <li role="separator" className="divider"></li>
                        <li>
                            <a onClick={() => {
                                $('#table-view-image-input').click();
                            }}>
                                <form id="myform">
                                    <label htmlFor="table-view-image-input">
                                        <span>Upload Background Image</span>
                                    </label>
                                    {
                                        isUploadingImage ?
                                        <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} /> :
                                        <input
                                            key={inputKey}
                                            onChange={this.uploadBackgroundImage}
                                            id="table-view-image-input"
                                            type="file"
                                            name="fileToUpload"
                                            id="fileToUpload" />
                                    }
                                </form>
                            </a>
                        </li>
                        </>
                    }
                    <li role="separator" className="divider"></li>
                    <h6 className="dropdown-header">Aspect Ratio</h6>
                    {aspectRatios.map((aspectRatio, index) => {
                        let custom = ""
                        if (selectedAspectRatio == 'Custom' && aspectRatio == 'Custom') {
                            custom = ` (${customAspectRatio})`
                        }
                        return <li key={index}>
                            <a onClick={() => this.onAspectRatioChanged(aspectRatio) }>
                                {(selectedAspectRatio == aspectRatio || (aspectRatio == 'Custom' && custom)) && tickSymbol}
                                <span style={{display: "inline-block"}}>{aspectRatio}{custom}</span>
                            </a>
                        </li>
                    })}
                </ul>
            </div>
        </div>
    }

    getSelectedAspectRatioValue = () => {
        if (this.state.selectedAspectRatio == 'Custom') {
            return this.state.customAspectRatio
        }
        return this.state.selectedAspectRatio
    }
    render = () => {
        const {allowScroll, canvasSelectedTable} = this.state
        var w = window.innerWidth;
        var h = window.innerHeight;
        let cH, cW;
        let canvasStyle = { }

        const aspectRatioComponents = this.getSelectedAspectRatioValue().split(":")
        const aspectRatio = aspectRatioComponents[0] / aspectRatioComponents[1]
        const isLandscape = w > h
        const isPortrait = !isLandscape

        if ( isLandscape ) {
            // Landscape
            cW = (w * 0.70)
            cH = (cW / aspectRatio)
            const maxCanvasHeight = h * 0.70
            if (!allowScroll && cH > maxCanvasHeight) {
                // Canvas too long to fit on screen. Adjust height.
                cH = maxCanvasHeight
                cW = maxCanvasHeight * aspectRatio
            }
        }
        else {
            // Portrait mode
            const maxCanvasWidth = h * 0.90
            cW = (w * 0.90)
            cH = (cW / aspectRatio)
        }

        this.canvasWidth = cW
        this.canvasHeight = cH

        canvasStyle = {
            width: cW + "px",
            height: cH + "px",
            border:"1px solid #d3d3d3"
        }
        return (
            <React.Fragment>
                {
                    isPortrait &&
                    <div className="mb-1 mt-3 clearfix" style={{minHeight: "40px"}}>
                        {
                            this.tableActionButtons(isLandscape, canvasSelectedTable)
                        }
                        {
                            this.props.showButtons && this.getButtons()
                        }
                    </div>
                }

                <div style={{display:"flex", margin:"auto",}} className="mb-3">
                    <div style={{flex:"1 0 500px", textAlign:"right", position: this.state.isSaving ? "relative" : "static"}}>
                        <canvas disabled ref={this.tableCanvas} id="seat-selector" width={cW} height={cH} style={canvasStyle} ></canvas>
                        {
                            this.state.isSaving && <div style={{height:cH, width: cW, backgroundColor:"#d3d3d355", position:"absolute", top:0, right:0, display:"flex"}}>
                                <div style={{margin:"auto"}}>
                                    Saving...
                                    <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} />
                                </div>
                            </div>
                        }
                        <div style={{textAlign: "right", fontSize: "16pt"}}>
                            {
                                this.props.currentCounter && this.props.currentCounter.name
                            }
                        </div>
                    </div>
                    {
                        isLandscape && this.tableActionButtons(isLandscape, canvasSelectedTable)
                    }
                </div>
            </React.Fragment>
        );
    }

    tableActionButtons = (isLandscape, canvasSelectedTable) => {
        let buttons = []
        let extraStyle = {}
        if (this.state.isEditMode) {
            extraStyle = {overflowY:"auto", padding: "0px 10px 0px 0px"}
            buttons = canvasSelectedTable && this.editTableShapeButtons(isLandscape, canvasSelectedTable)
        }
        else {
            buttons = this.operationalTableButtons(isLandscape, canvasSelectedTable)
        }

        if (isLandscape) {
            let style = { ...extraStyle, height:"75vh",flex:"0 0 200px", flexDirection:"column", textAlign: "right", display: "flex", alignItems: "end"}
            return <div className="ml-2" style={style}>
                {buttons}
            </div>
        }
        else {
            let style = {
                display:"flex"
            }
            if (!isLandscape) {
                style["flexWrap"] = "wrap"
            }
            return <span className="" style={style}>
                {buttons}
            </span>
        }
    }
    editTableShapeButtons = (isLandscape, canvasSelectedTable) => {
        const onChange = (absoluteDetail) => {
            const absolute = {...absoluteDetail}
            this.setState({
                tempTableDetail: {
                    absolute: absolute,
                    relative: this.transformCoordinateToRelative(absolute, this.canvasWidth, this.canvasHeight),
                }
            })
        }
        return <EditShapeMenu
            key={canvasSelectedTable.id}
            buttonsOnly={true}
            direction={isLandscape ? "vertical" : "horizontal"}
            table={this.state.canvasSelectedTable}
            details={this.state.tempTableDetail.absolute}
            onSave={(table) => {}}
            onChange={onChange}
            trailing={[
                <div key={0} style={{padding: "10px"}}>
                    <CancelButton direction='vertical' onClick={() => this.setState({canvasSelectedTable: null, selectedForEditTable: null})}/>
                    <button className="btn btn-success ml-2" onClick={this.onSaveTableDetailsClicked}>Save</button>
                </div>
            ]} />
    }
    operationalTableButtons = (isLandscape, canvasSelectedTable) => {
        let merchantSettings = this.props.parent.props.app.state.merchant.settings;
        let hasDrawer = merchantSettings && merchantSettings.indexOf("has_drawer") > 0;
        if (isLandscape) {
            return canvasSelectedTable ?
                <>
                    <TableActionButtons
                        direction="vertical"
                        textAlign="right"
                        table={canvasSelectedTable}
                        parent={this.props.parent}
                        app={this.props.parent.props.app}
                        trailing={[
                            <CancelButton key={0} direction='vertical' onClick={() => this.setState({canvasSelectedTable: null})}/>
                        ]} />
                </> :
                <>
                    {
                        hasDrawer &&
                        <button className="btn btn btn-primary" onClick={MerchantAppData.triggerOpenDrawer}>
                            <i className="fa fa-money-check-alt mr-2"></i> {lang.open_drawer}
                        </button>
                    }

                    {
                        this.props.parent.props.app.getMerchantSettingValue(MerchantSettingKey.TABLE_CANVAS_VIEW_SHOW_TABLE_ACTIVE_TIME) == 1 &&
                        <>
                            <div className="mt-2"></div>
                            <TableActiveTimeList app={this.props.parent.props.app} tables={this.props.tables} tableSessionWithActiveOrdersArr={this.props.parent.props.app.state.tableSessionWithActiveOrdersArr} />
                        </>
                    }
                </>
        }
        else {
            return canvasSelectedTable &&
                <>
                    <div style={{flex:"1 0 auto"}}>
                        <TableActionButtons
                            table={canvasSelectedTable}
                            parent={this.props.parent}
                            app={this.props.parent.props.app} />
                    </div>
                    <div style={{flex:"0 1 auto"}}>
                        <CancelButton direction='horizontal' onClick={() => this.setState({canvasSelectedTable: null})}/>
                    </div>
                </>
        }
    }

    /// Transform relative coordinates to absolute coordinates
    transformCoordinateToAbsolute = (relativeDetail, maxWidth, maxHeight) => {
        let parsed = {...relativeDetail}
        this.parseFloatMulti(['x','y','width','height','cr_tl','cr_tr','cr_bl','cr_br'], parsed)
        let absolute = {
            ...relativeDetail,
            x: relativeDetail.x * maxWidth,
            y: relativeDetail.y * maxHeight,

            width: relativeDetail.width * maxWidth,
            height: relativeDetail.height * maxHeight,

            // t - top, b - bottom, l - left, r - right
            cr_tl: relativeDetail.cr_tl,
            cr_tr: relativeDetail.cr_tr,
            cr_bl: relativeDetail.cr_bl,
            cr_br: relativeDetail.cr_br,
        }
        return absolute
    }
    /// Transform absolute coordinates to relative coordinates
    transformCoordinateToRelative = (absoluteDetail, maxWidth, maxHeight) => {
        let parsed = {...absoluteDetail}
        this.parseFloatMulti(['x','y','width','height','cr_tl','cr_tr','cr_bl','cr_br'], parsed)
        let relative = {
            ...absoluteDetail,
            x: parsed.x / maxWidth,
            y: parsed.y / maxHeight,

            width: parsed.width / maxWidth,
            height: parsed.height / maxHeight,

            // t - top, b - bottom, l - left, r - right
            cr_tl: parsed.cr_tl,
            cr_tr: parsed.cr_tr,
            cr_bl: parsed.cr_bl,
            cr_br: parsed.cr_br,
        }
        return relative
    }

    /// To fix issue where <input/> may accept number like "6.22..", which considered
    /// valid numbers, but will throw error when perform calculation like "6.22." * 1
    parseFloatMulti = (keys, source) => {
        keys.forEach(key => {
            let value = source[key]
            if (typeof value !== 'undefined' || value !== null) {
                source[key] = parseFloat(value)
            }
        })
    }
}

function CancelButton({direction, onClick}) {
    const isVertical = direction == 'vertical'
    const btnClass = isVertical ? "" : "btn-sm"
    return <button className={`btn ${btnClass} btn-danger`} onClick={onClick}>{isVertical ? lang.cancel : <span>&times;</span>}</button>
}

TableCanvasView.defaultProps = {
    tableRadius: 0.04,
    aspectRatio: "4:3",
}

export default TableCanvasView;